<template>
  <v-jumbotron color="grey lighten-2">
    <v-container fill-height>
      <v-layout align-center>
        <v-flex>
          <h3 class="display-3">Welcome to book•me</h3>
          <span class="subheading">The smart booking tool. Here you can manage all your resources, events and bookings.</span>
          <!--<v-divider class="my-3"></v-divider>-->
          <!--<div class="title mb-3">Check out our newest features!</div>-->
          <!--<v-btn large color="primary" class="mx-0">See more</v-btn>-->
        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: "Home",
    created() {
      this.setActiveMenu('Home');
      this.setActiveSubmenu('');
    },
    methods: {
      ...mapActions([
        'setActiveMenu',
        'setActiveSubmenu'
      ])
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue